import { render, staticRenderFns } from "./Entry-ResellerCommission.vue?vue&type=template&id=062b4757&"
import script from "./Entry-ResellerCommission.vue?vue&type=script&lang=js&"
export * from "./Entry-ResellerCommission.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports